import { render, staticRenderFns } from "./ZddRecordDetail.vue?vue&type=template&id=c7bce33a&scoped=true"
import script from "./ZddRecordDetail.vue?vue&type=script&lang=js"
export * from "./ZddRecordDetail.vue?vue&type=script&lang=js"
import style0 from "./ZddRecordDetail.vue?vue&type=style&index=0&id=c7bce33a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7bce33a",
  null
  
)

export default component.exports